import React from 'react';

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export class SortNumberButton extends React.Component{
    render(){
        return(
            <button className='Round-button' style={this.props.style} key={this.props.key} id={this.props.id} value={this.props.value} onClick={this.props.onClick} >
                {this.props.value}
            </button>
        )};
}